// extracted by mini-css-extract-plugin
module.exports = {"sphere":"index_sphere_2k--o","selectcard":"index_selectcard_M6Ipx"};